import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
	get_property_details,
	reset,
} from '../../features/property/propertySlice'
import { create_inspection } from '../../features/inspection/inspectionSlice'
import Loader from '../../components/Loader'
import { Link } from 'react-router-dom'
import { comma } from '../../utils/helper'
import ModalComponent from '../../components/ModalComponent'

const PropertyDetails = () => {
	const dispatch = useDispatch()
	const params = useParams()

	const { loading, propertyDetails } = useSelector(
		(state) => state.propertyGetTypes
	)

	const { loading: loadingPost } = useSelector((state) => state.allInspection)

	const [openModal, setOpenModal] = useState(false)

	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [phone, setPhone] = useState('')
	const [date, setDate] = useState('')
	const [time, setTime] = useState('')
	const [feedback, setFeedback] = useState(null)

	const submitHandler = (e) => {
		e.preventDefault()
		if (
			name !== '' &&
			email !== '' &&
			phone !== '' &&
			date !== '' &&
			time !== ''
		) {
			let data = {
				name,
				email,
				phone,
				date,
				time,
				property:
					propertyDetails &&
					propertyDetails.property &&
					propertyDetails.property.propertyName +
						', ' +
						propertyDetails.property.location,
			}

			dispatch(create_inspection(data))

			setTimeout(() => {
				setName('')
				setEmail('')
				setPhone('')
				setDate('')
				setTime('')
				setOpenModal(false)
			}, 500)
		} else {
			setFeedback('Please fill all fields')
		}
	}

	const toggleModal = () => {
		setOpenModal(!openModal)
	}

	useEffect(() => {
		dispatch(get_property_details(params.id))

		return () => {
			dispatch(reset())
		}
	}, [dispatch, params.id])

	return (
		<section className='user_dashboard section novi-background section-md text-center'>
			{loading ? (
				<Loader />
			) : (
				propertyDetails &&
				propertyDetails.property && (
					<>
						<div className='container'>
							<div className='d-flex justify-content-between'>
								<h3 className='text-uppercase font-weight-bold wow-outer pt-5'>
									<span className='wow slideInDown'>
										{propertyDetails.property.propertyName}
									</span>
								</h3>
								<Link
									to='#'
									onClick={(e) => {
										e.preventDefault()
										setOpenModal(true)
									}}
									className='btn btn-secondary text-white'
									style={{
										height: '2.5rem',
										marginTop: '3.2rem',
										fontWeight: '700',
									}}
								>
									Book Inspection
								</Link>
							</div>

							<div className='row'>
								<div className='col-md-6'>
									<img src={propertyDetails.property.displayImage} alt='' />
								</div>
								<div className='col-md-6'>
									<div
										className='card py-3 px-3'
										style={{ boxShadow: '1px 1px 3px #ccc' }}
									>
										<div className='d-flex'>
											<h6> Location: </h6>
											<h6> {propertyDetails.property.location} </h6>
										</div>
										<div className='d-flex'>
											<h6> Price: </h6>
											<h6 className='ml-3 pt-0 mt-0'>
												&#8358;{comma(propertyDetails.property.price)}
											</h6>
										</div>
										<div className='d-flex'>
											<h6>Description: </h6>
											<p> {propertyDetails.property.description} </p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				)
			)}
			<ModalComponent
				open={openModal}
				toggle={toggleModal}
				size='lg'
				title='Book Inspection'
			>
				<div className='login_form'>
					<form className='tagForm' onSubmit={submitHandler}>
						<label htmlFor='your_name' className='label'>
							Your Name
						</label>
						<input
							type='text'
							id='your_name'
							value={name}
							required
							className='form-control mb-3'
							onChange={(e) => setName(e.target.value)}
						/>
						<label htmlFor='email' className='label'>
							Your Email
						</label>
						<input
							type='text'
							id='email'
							name='email'
							value={email}
							required
							className='form-control mb-3'
							onChange={(e) => setEmail(e.target.value)}
						/>
						<label htmlFor='mobile' className='label'>
							Your Phone Number
						</label>
						<input
							type='text'
							id='mobile'
							name='mobile'
							required
							value={phone}
							className='form-control mb-3'
							onChange={(e) => setPhone(e.target.value)}
						/>
						<label htmlFor='property' className='label'>
							Property
						</label>
						<input
							type='text'
							id='property'
							value={
								propertyDetails &&
								propertyDetails.property &&
								propertyDetails.property.propertyName
							}
							className='form-control mb-3'
							disabled
						/>
						<label htmlFor='date_of_visit' className='label'>
							Date
						</label>
						<input
							type='date'
							name='date'
							id='date_of_visit'
							required
							className='form-control mb-3'
							onChange={(e) => setDate(e.target.value)}
						/>

						<label htmlFor='time_of_visit'>Time</label>
						<select
							id='time_of_visit'
							onChange={(e) => setTime(e.target.value)}
							className='form-select mb-3'
							required
						>
							<option value=''> -- select time -- </option>
							<option value='12:00pm'>12:00pm</option>
							<option value='3:00pm'>3:00pm</option>
						</select>

						<div className='d-flex justify-content-between mt-4'>
							<div>
								<button
									disabled={loadingPost ? true : false}
									className='btn btn-secondary'
								>
									{loadingPost ? (
										<i className='fas fa-spinner fa-spin'></i>
									) : (
										'Send'
									)}
								</button>
								<p style={{ fontSize: '12px', color: 'red' }}>{feedback}</p>
							</div>
						</div>
					</form>
				</div>
			</ModalComponent>
		</section>
	)
}

export default PropertyDetails
